import createIcon from '../../createIcon';

/**
 * @component @name GppMaybe
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkw0IDVWMTEuMDlDNCAxNi4xNCA3LjQxIDIwLjg1IDEyIDIyQzE2LjU5IDIwLjg1IDIwIDE2LjE0IDIwIDExLjA5VjVMMTIgMlpNMTMgMTZIMTFWMTRIMTNWMTZaTTEzIDEySDExVjdIMTNWMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GppMaybe = createIcon('GppMaybe', [
  [
    'path',
    {
      d: 'M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM13 16H11V14H13V16ZM13 12H11V7H13V12Z',
      key: 'p7hr5n',
    },
  ],
]);

export default GppMaybe;
